<div class="d-flex flex-row" style="cursor: pointer">
    <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-column mr-2">
            <h4 class="mb-0"><i class="bi bi-telephone-x-fill mr-1"></i> {{ count }} missed call{{ count > 1 ? 's' : '' }} today</h4>
        </div>
        <button class="ml-auto" (click)="view()">View</button>
    </div>
</div>
